jQuery(function($){

	// Print Button
    $('.print-page .nav__link').click(function(){
        window.print();
        return false;
    });

});